<div class="feature-hero">
  <ui-glow-shadow-container>
    <div class="container glow-shadow__container">
      <div class="flex">
        <div class="feature-hero__container">
          <img [src]="src" [alt]="altTag" />
        </div>
        <div class="md-ml-6 md-pl-12 feature-hero__content">
          <h5 class="pt-6 pb-4">{{ featureTitle }}</h5>
          <ul class="pb-6">
            <li *ngFor="let feature of topFeatures" class="feature-hero__list">
              <dgx-components-icon
                [svgIcon]="iconName | iconName"
              ></dgx-components-icon>
              <span class="pl-4"> {{ feature.title }}</span>
            </li>
          </ul>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </ui-glow-shadow-container>
</div>
